import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import api from '../services/api';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [packageInfo, setPackageInfo] = useState(null);

  useEffect(() => {
    const loadPaymentData = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        navigate('/dashboard');
        return;
      }

      try {
        // Refresh user data
        if (refreshUser) {
          await refreshUser();
        }

        // Get package info from session
        const response = await api.get(`/payment/session/${sessionId}`);
        setPackageInfo(response.data);
      } catch (error) {
        console.error('Error loading payment data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPaymentData();
  }, [searchParams, refreshUser, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-3xl w-full">
        
        {/* Success Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-green-100 rounded-full mb-6">
            <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Zahlung erfolgreich!
          </h1>
          
          <p className="text-xl text-gray-600 mb-2">
            Hey {user?.firstname || 'Gitarrist'} 👋
          </p>
        </div>

        {/* Package Info */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 mb-8 text-center">
          <p className="text-gray-600 mb-3">
            Du hast erfolgreich das
          </p>
          <div className="text-3xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent mb-3">
            {packageInfo?.name || 'Guitar Academy Paket'}
          </div>
          <p className="text-gray-600">
            gekauft und hast ab sofort <span className="font-semibold text-gray-900">vollen Zugriff</span> auf alle Kurse!
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          <div className="text-center">
            <div className="text-3xl mb-2">🎥</div>
            <p className="text-sm text-gray-600 font-medium">Video-Lektionen</p>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-2">📈</div>
            <p className="text-sm text-gray-600 font-medium">Fortschritt-Tracking</p>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-2">🎸</div>
            <p className="text-sm text-gray-600 font-medium">Strukturierte Kurse</p>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-2">⏰</div>
            <p className="text-sm text-gray-600 font-medium">Lebenslanger Zugriff</p>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button
            onClick={() => {
              window.location.href = '/dashboard';
            }}
            className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 text-white text-lg font-semibold rounded-lg hover:from-primary-700 hover:to-secondary-700 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Jetzt loslegen
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>

      </div>
    </div>
  );
};

export default PaymentSuccess;
